import { render, staticRenderFns } from "./FormWizard.vue?vue&type=template&id=6213bdf7&scoped=true&"
import script from "./FormWizard.vue?vue&type=script&lang=js&"
export * from "./FormWizard.vue?vue&type=script&lang=js&"
import style0 from "./FormWizard.vue?vue&type=style&index=0&id=6213bdf7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6213bdf7",
  null
  
)

export default component.exports